import { Component } from '@angular/core';
import { LegService } from '@approot/services/leg/leg.service';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';

@Component({
  selector: 'extra-results-attributes',
  templateUrl: './extra-results-attributes.component.html',
  styleUrls: ['./extra-results-attributes.component.scss']
})
export class ExtraResultsAttributesComponent {
  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService
  ) {}

  get markUpExpanded() {
    return this.legService.markUpExpanded;
  }

  set markUpExpanded(val) {
    this.legService.markUpExpanded = val;
  }

  get activeExtraAttributes() {
    return this.legService.activeExtraAttributes;
  }

  get markUpSpecifications() {
    return this.productsConfigService.pricingResultsInfo.markUpSpecifications;
  }
}
